export enum ServicesQueryKeys {
  Address = 'address',
  AddressSubscriptions = 'address-subscriptions',
  ServiceProviders = 'service-providers',
  ServiceOffers = 'service-offers',
  ServiceOffer = 'service-offer',
  Municipalities = 'municipalities',
}
